"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { generateCurrentPath } from "@helpers/urlHelper";
import { generateBreadcrumbStructuredData } from "@utils/clientStructuredData";
import { generateClientBreadcrumbs } from "@utils/clientBreadcrumbUtils";
import { parsePricePagePathname } from "@helpers/pricePageCanonical";

const DynamicSEO = () => {
  const pathname = usePathname();

  useEffect(() => {
    const updateSEO = async () => {
      try {
        // Update canonical URL
        const isPricePage = Boolean(parsePricePagePathname(pathname));
        const pageCanonicalUrl = document
          .querySelector('meta[name="acko:canonical-url"]')
          ?.getAttribute("content");
        const canonicalUrl =
          isPricePage && pageCanonicalUrl
            ? pageCanonicalUrl
            : generateCurrentPath(pathname);
        let canonicalLink = document.querySelector('link[rel="canonical"]');
        
        if (!canonicalLink) {
          canonicalLink = document.createElement('link');
          canonicalLink.setAttribute('rel', 'canonical');
          document.head.appendChild(canonicalLink);
        }
        
        canonicalLink.setAttribute('href', canonicalUrl);

        // Update breadcrumb structured data
        const breadcrumbs = await generateClientBreadcrumbs(pathname);
        const breadcrumbStructuredData = generateBreadcrumbStructuredData(breadcrumbs);

        if (breadcrumbStructuredData) {
          let breadcrumbScript = document.querySelector('script[data-breadcrumb-structured-data]');
          
          if (!breadcrumbScript) {
            breadcrumbScript = document.createElement('script');
            breadcrumbScript.setAttribute('type', 'application/ld+json');
            breadcrumbScript.setAttribute('data-breadcrumb-structured-data', 'true');
            document.head.appendChild(breadcrumbScript);
          }
          
          breadcrumbScript.textContent = breadcrumbStructuredData;
        }
      } catch (error) {
        console.error('Error updating SEO:', error);
      }
    };

    updateSEO();
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default DynamicSEO;
